import React from 'react'

const Aboutus = () => {
    return (
        <div className='w-full lg:py-16 py-3 h-auto flex flex-col lg:gap-16 gap-8 lg:px-32 px-5' id='aboutus'>
            <div>
                <h1 className='font-semibold text-4xl text-center'>About Us</h1>
            </div>
            <div className='flex lg:flex-row flex-col gap-10'>
                <div className='flex-1 flex flex-col gap-5'>
                    <p className='font-semibold'>Welcome to AndreNacouziHomeSchool! I've been helping students for more than 10 years, teaching math, physics, and chemistry for different school programs like Lebanese, French, British, and American. I offer both in-person and online sessions. I've come up with my own way of teaching these subjects, and i use the latest tools to make learning fast and fun. Let's make studying an exciting adventure together at ANHS!</p>
                    {/* <div className='w-full flex gap-2 lg:justify-start justify-center'>
                        <a href='#contact'><button type="button" className="text-white bg-gray-500 hover:bg-gray-800 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 mb-5">Contact Us For More</button></a>
                    </div> */}
                </div>
                <div className='flex-1 lg:mb-0 mb-5'>
                    <iframe className='w-full min-h-72' height={300} src="https://www.youtube.com/embed/0jElHzyo2H4?si=MT-orypCvAH8mYzN" title="anhs" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen={true}></iframe>
                </div>
            </div>
        </div>
    )
}

export default Aboutus